import styles from "../../Styles/Generalinfo.module.scss";
import info from "../../img/England/General_Information_England.pdf";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

function Generalinfo() {
  const insurance = {
    href: "https://www.travelguard.com/",
    target: "_blank"
  };
  const visa = {
    href: "https://www.ukvisaportal.com/?utm_source=google&amp;utm_medium=ppc&amp;utm_campaign=23375063654&amp;utm_term=eta%20for%20uk&amp;utm_content=190245513293_%7Badid%7D&amp;gad_source=1&amp;gad_campaignid=23375063654&amp;gbraid=0AAAABA9sZSzsUlXK2H0vqKWc5SZC-8XTD&amp;gclid=CjwKCAiA09jKBhB9EiwAgB8l-ONWJMzz8brPaY9qhCxtlRdahagFbkh5140D2iMTADD4R7bdTlWCoxoCY0sQAvD_BwE",
    target: "_blank"
  };

  const [justTrip, setJustTrip] = useState(false);
  const params = useParams();

  let dates = "";
  let cost = "";
  let groupSize = "";
  let servicesIncluded = [];
  let servicesExcluded = [];

  const servicesIncludedJune = [
    "Transportation in country",
    "Accommodation for 9 nights",
    "Entry costs to all sites and activities listed in the itinerary",
    "Guide and teaching: Dr. Dan Glick",
    "Access to all pre trip materials (see below)"
  ];
  const servicesExcludedJune = [
    "Airfare",
    "Meals after breakfast",
    "Medical, traveler’s or personal insurance.",
    "Personal expenses",
    "Passport and ETA entry permit (see Travel Documentbelow to know how to secure this.)"
  ];

  switch (params.trip) {
    case "June_1-11-26":
      dates = "June 1 - 11, 2026";
      cost = "$2,620 (double occupancy) airfare and meals after breakfast";
      groupSize = "10 - 14";
      servicesIncluded = servicesIncludedJune;
      servicesExcluded = servicesExcludedJune;
      break;
    case "trip":
      dates = "TBA";
      cost = "TBA";
      groupSize = "14-28";
      servicesIncluded = servicesIncludedJune;
      servicesExcluded = servicesExcludedJune;

      break;
  }

  useEffect(() => {
    if (params.trip === "trip") {
      console.log("yes");
      setJustTrip(true);
    } else {
      setJustTrip(false);
    }
  }, []);

  return (
    <div className="pageContainer">
      <div className="title">England Tour</div>
      {!justTrip ? (
        <div className="printBox">
          {/* <div className="print">
            <a href={info} target="_blank" rel="noreferrer">
              Print PDF
            </a>
          </div> */}
        </div>
      ) : (
        ""
      )}
      <div>
        <div className={styles.paragraphTitle}>TRIP DATES</div>
        <p className="text">{dates}</p>
      </div>

      <div>
        <div className={styles.paragraphTitle}>GROUP SIZE</div>
        <p className="text">{groupSize}</p>
      </div>
      <div>
        <div className={styles.paragraphTitle}>COST</div>
        <p className="text">{cost}</p>
      </div>
      <div>
        <div className={styles.paragraphTitle}>
          SERVICES INCLUDED IN THE PRICE
        </div>
        <ul className={styles.servicesList}>
          {servicesIncluded.map((par) => (
            <li className={styles.list}>{par}</li>
          ))}
        </ul>
      </div>
      <div>
        <div className={styles.paragraphTitle}>
          SERVICES NOT INCLUDED IN THE PRICE
        </div>
        <ul className={styles.servicesList}>
          {servicesExcluded.map((par) => (
            <li className={styles.list}>{par}</li>
          ))}
        </ul>
      </div>
      <div>
        <div className={styles.paragraphTitle}>DOCUMENTS</div>
        <p className="text">
          You will need a USA passport. Make sure your passport is valid and
          does not expire at least six months AFTER your re-entry date to the
          United States. You will also need an ETA entry permit fee (to be
          applied for by travelers). For detailed information and to apply,
          please visit
          <a {...visa} rel="norferrer" className={styles.link}>
            ukvisaportal.com
          </a>
          . This is a new requirement for all American citizens traveling to the
          UK since 2025.
        </p>
      </div>
      <div>
        <div className={styles.paragraphTitle}>INSURANCE</div>
        <p className="text">
          [OPTIONAL] If you wish to insure your trip, we recommend you use
          Travel Guard. There are many travel insurance companies out there,
          however, and one of them may prove to be a better option for you. You
          can visit
          <a {...insurance} rel="norferrer" className={styles.link}>
            TravelGuard.com
          </a>
          or call them at <span className={styles.highlight}>800-826-5248</span>
          . They have multiple options for insuring anything from the flight
          itself to the full cost of the trip. Most plans cover sickness,
          injury, or death of a family member.
        </p>
      </div>
      <div>
        <div className={styles.paragraphTitle}>
          CANCELLATION AND REFUND POLICY
        </div>
        <p className="text">
          If you need to cancel your tour, you can do it provided it is 90 days
          before the tour date. After this, the trip is generally non-refundable
          due to contracts with hotels, guides, and transportation services.
        </p>
      </div>
      <div>
        <div className={styles.paragraphTitle}>HOW TO SIGN UP FOR THE TRIP</div>
        <p className="text">
          Contact Dan Glick at 
          <span className={styles.highlight}>danglick62@gmail.com</span>and
          provide your full passport name (exactly as it appears on your
          passport), date of birth, phone number, email address, and physical
          address. Then send in your deposit.
        </p>
      </div>
      <div>
        <div className={styles.paragraphTitle}>DEPOSIT</div>
        <p className="text">
          A $500 deposit is required to reserve your seat on this trip. Only a
          check is accepted as a form of payment. Checks should be made to Tribe
          of Dan Tours and mailed to Dan Glick, 9850 Cedar Cove, Alexandria, KY
          41001.
        </p>
      </div>
      <div>
        <div className={styles.paragraphTitle}>PAYMENT POLICY</div>
        <p className="text">
          <span className={styles.highlightItalic}>
            The final payment will be due 90 days before departure.
          </span>{" "}
          Only a check is accepted as a form of payment. Checks should be made
          to: Tribe of Dan Tours and mailed to Dan Glick, 9850 Cedar Cove,
          Alexandria, KY 41001.
        </p>
      </div>
      {/* <div>
        <div className={styles.paragraphTitle}>
          AUDIO TOUR GUIDE SOUND SYSTEM
        </div>
        <p className="text">
          Tribe of Dan Tours makes use of an audio tour guide sound receiver.
          With this receiver and the accompanying earbud, you will be able to
          hear your guide wherever you are in the group
        </p>
      </div> */}
      <div>
        <div className={styles.paragraphTitle}>PRE-TRIP MATERIALS</div>
        <p className="text">
          Tribe of Dan Tours provides the following documents: 1) An itinerary
          2) A list of YouTube videos that one can watch about the country and
          sites of Israel. This is very helpful information prior to the trip,
          and Dan strongly encourages all tourists to take advantage of this and
          watch them in the months prior to the trip. 3) A suggestive packing
          list. 4) A prayer guide. 5) Some travel advice. 6) A gallery of
          photos.
        </p>
      </div>
      <div>
        <div className={styles.paragraphTitle}>PHYSICAL REQUIREMENTS</div>
        <p className="text">
          There is substantial walking on this trip. It is recommended that you
          get a good amount of walking exercise in the weeks preceding the trip.
          There are no special vaccines required for entry into England.
        </p>
      </div>
    </div>
  );
}

export default Generalinfo;
